function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, CircularProgress, styled } from "@mui/material";
var StyledModalBody = styled('div', {
    shouldForwardProp: function(prop) {
        return prop !== 'isRounded';
    }
})(function(props) {
    return {
        /** WCAG 1.4.10 */ '@media (max-height: 500px)': {
            overflow: 'unset'
        },
        borderRadius: props.isRounded ? '0.75rem' : undefined,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        height: '100%',
        overflow: 'hidden'
    };
});
var StyledModalBodyContents = styled('div')(function(props) {
    return _define_property({
        /** WCAG 1.4.10 */ '@media (max-height: 500px)': {
            overflowY: 'unset'
        },
        overflowY: 'auto',
        padding: props.theme.spacing(10, 10),
        webkitOverflowScrolling: 'touch'
    }, props.theme.breakpoints.down('sm'), {
        padding: props.theme.spacing(10, 6)
    });
});
export var ModalBody = function(_param) {
    var isRounded = _param.isRounded, props = _object_without_properties(_param, [
        "isRounded"
    ]);
    return /*#__PURE__*/ _jsx(StyledModalBody, {
        isRounded: isRounded,
        children: /*#__PURE__*/ _jsxs(StyledModalBodyContents, _object_spread_props(_object_spread({
            className: props.isLoading ? 'flex flex-col items-center' : '',
            "data-component": "modalBody",
            role: "presentation"
        }, props), {
            children: [
                props.isLoading && /*#__PURE__*/ _jsx(CircularProgress, {
                    "data-component": "modalLoader"
                }),
                typeof props.error === 'string' && /*#__PURE__*/ _jsx(Alert, {
                    dangerouslySetInnerHTML: {
                        __html: props.error
                    },
                    "data-component": "modalError",
                    severity: "error"
                }),
                props.error && typeof props.error !== 'string' && /*#__PURE__*/ _jsx(Alert, {
                    "data-component": "modalError",
                    severity: "error",
                    children: props.error
                }),
                !props.isLoading && props.children
            ]
        }))
    });
};
ModalBody.displayName = 'ModalBody';

//# sourceMappingURL=ModalBody.js.map